<template>
  <div>
    <h3 ref="def">
      What is a Local Maxima or Minima?
    </h3>
    <p> Let's start by understanding what is a local maxima or minima of a function. </p>
    <h5> Local Maxima of a Function </h5>
    <p>
      Let's say you are given a function \(y = f(x)\). Then, a local maxima of this
      function is a point, say \(x=x_{max}\), at which this function attains a maximum value in its immediate locality.
      This means you cannot find any other point in the near vicinity of point \(x=x_{max}\)
      at which the function's value is greater than that at \(x=x_{max}\).
    </p>x
    <h5> Local Minima of a Function </h5>
    <p>
      A local minima of a function is a point, say \(x = x_{min}\), at which the function attains
      a minimum value in its immediate locality. This means you cannot find any other point in the near vicinity of point \(x=x_{min}\)
      at which the function's value is smaller than that at \(x=x_{min}\).
    </p>
    <!--
<h5> Example </h5>
<p> For this example, we will consider the following function
 $$f(x) = 0.5x^3 +x +2 $$
The curve representing this function is shown below.
This function has a local maxima at point 'A' and a local  minima at point 'B'.
Point 'P' is a draggable point that can glide along the curve representing function f(x).
Drag point 'P' through the local maxima and local minima.
-->
    </p>
    <h3 ref="sol">
      Finding Local Maxima using First Derivative
    </h3>
    <p>
      At a local maxima, the first derivative of the function is zero. Thus, if \(x = x_{max}\) is a local maxima, Then
      $$f'(x=x_{max}) =0$$
    </p>
    <br>
    <h3 ref="sol">
      Finding Local Minima using First Derivative
    </h3>
    <p>
      At a local maxima, the first derivative of the function is zero. Thus, if \(x = x_{max}\) is a local maxima, Then
      $$f'(x=x_{min}) =0$$
    </p>
    <br>
    <h3 ref="pg">
      MagicGraph | Local Maxima & Minima of a Function
    </h3>
    <p>
      The MagicGraph below offers a visually interactive module to explain local maxima and local minima
      of a function.
    </p>
    <h5>To Get Started</h5>
    <p>
      This MagicGraph shows the curves representing function \(f(x)\) and its derivative \(f'(x)\).
      The bright RED point is a draggable point that can glide on the curve representing function \(f(x)\).
      Dragging the RED point will make the bright BLUE point glide along the curve representing \(f'(x)\).
    </p>
    <v-responsive>
      <v-layout justify-center>
        <div id="jxgbox1" class="edliy-box-about" />
      </v-layout>
    </v-responsive>
  </div>
</template>
<script>
import Boxes from './Boxes.js'
export default {
  name: 'MaximaMinima',
  created: function () {
    // Store mutations
    this.$store.commit('navigation/resetState');
    let title = 'Maxima & Minima';
    this.$store.commit('navigation/changeTitle', title);
    this.$store.commit('navigation/changeMenu', title);
    let newTopics = [
      {title: 'Square Formula', img:'/assets/number-1.svg', action: () => this.goto('ia')},
      {title: 'MagicGraph',img:'/assets/touch.svg', action: () => this.goto('playgraph')},
    ];
    this.$store.commit('navigation/replaceTopics', newTopics);
    let newshowhome = false;
    this.$store.commit('navigation/toggleshowhome', newshowhome);
    let newMath =true;
    this.$store.commit('navigation/replaceMath', newMath);
    let newLeftArrow =true;
    this.$store.commit('navigation/replaceLeftArrow', newLeftArrow);
    let newModule=true;
    this.$store.commit('navigation/replaceModule', newModule);
  },
  mounted () {
    MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    Boxes.box1();
  },
  metaInfo() {
  return{ title: 'Maxima & Minima',
          titleTemplate: '%s - Learn interactively',
          meta: [ {name: 'viewport', content: 'width=device-width, initial-scale=1'},
                  {name: 'description', content: 'Learn interactively about square formula'}
                ]
        }
   },
}
</script>
<style lang="scss">
@import 'src/styles/edliy-box.scss';
@import 'src/styles/subtopic-menu.scss';
@import 'src/styles/edliy-box-about.scss';
</style>
